import styled, { css } from 'styled-components';
import { typography } from 'styled-system';
import { getTextColor, getPaletteColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import { AddWishlistButton } from '../../molecules';
import { LIST } from '../../constants';
import Card from '../../atoms/Card';
import { Text as TextElement, Button, Chip } from '../../atoms';

const getContainer = (displayMode, containerWidth) => {
  const sizes = {
    miniature: css`
      display: grid;
      padding: 8px 2px;
    `,
    list: css`
      display: grid;
      grid-template-columns: 1.5fr 2fr;
      ${containerWidth >= 500 && css`
        ${getMediaQuery('small')} {
          grid-template-columns: 180px 2fr;
          grid-column-gap: 20px;
        }
      `}
      padding: 16px;
    `,
    gallery: css`
      grid-template-rows: auto auto 1fr;
    `
  };
  return sizes[displayMode];
};

export const SponsoredEl = styled(TextElement).attrs(props => Object.assign({
  fontSize: 13,
  fontWeight: 'regular',
  lineHeight: 'display'
}, props))`
  justify-self: left;
  color: ${getTextColor('light')};

  ${typography}
`;
export const WishlistBtn = styled(AddWishlistButton).attrs(props => Object.assign({
  width: 20,
  height: 20
}, props))`
  justify-self: end;
  max-width: 20px;
`;
export const Container = styled(Card)`
  position: relative;
  padding: 10px;
  justify-content: unset;
  background-color: ${props => props.hideLinkBorder ? 'unset' : getPaletteColor('background.lighter')(props)};
  ${({
  displayMode,
  containerWidth
}) => displayMode && getContainer(displayMode, containerWidth)};
  display: grid;

  ${({
  fullHeight
}) => fullHeight && `
    display: flex;
    flex-direction: column;
    height: 100%;
  `}
`;
const imgContainerDisplay = {
  miniature: css`
    height: 20vw;
    justify-content: flex-end;
    ${getMediaQuery('small')} {
      height: 120px;
    }
  `,
  list: css`
    justify-content: flex-start;
    padding-top: 4px;
    min-height: 25vw;
    & > img {
      max-height: 160px;
    }
    ${getMediaQuery('small')} {
      min-height: initial;
      max-height: 210px;
    }
  `,
  gallery: css`
    height: 32vw;
    justify-content: flex-end;
    ${getMediaQuery('small')} {
      max-height: 210px;
    }
  `
}; // "& > .lazyload-wrapper" stylizes the image's <LazyLoad> container

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
  ${({
  displayMode
}) => displayMode && imgContainerDisplay[displayMode]}
`;
const LoyaltyContainerDisplay = {
  miniature: css`
    justify-content: center;
  `,
  list: css`
    justify-content: flex-start;
  `,
  gallery: css`
    justify-content: flex-end;
  `
};
export const LoyaltyContainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  top: 5%;
  ${({
  displayMode
}) => displayMode && LoyaltyContainerDisplay[displayMode]}
`;
export const Title = styled(TextElement).attrs(props => Object.assign({
  fontSize: [1, 1, 1],
  lineHeight: 'display',
  fontWeight: 'regular'
}, props))`
  ${({
  displayMode
}) => displayMode !== LIST ? `height: 52px;` : `height: 32px;`};
  color: ${getTextColor('base')};
  -webkit-line-clamp: ${({
  displayMode
}) => displayMode !== LIST ? 3 : 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
  margin: 4px 0 4px 0;
  ${getMediaQuery('small')} {
    ${({
  displayMode
}) => displayMode === LIST && `height: 40px;`};
  }
  ${typography}
`;
export const Content = styled.div`
  ${({
  displayMode
}) => displayMode === LIST && `padding-left: 8px`}
  ${({
  displayMode
}) => displayMode !== LIST && `
    display: grid;
    padding-top: 8px;
  `}
`;
export const ButtonPreviewContainer = styled.div`
  width: 100%;
  height: 15px;
  position: relative;
`;
export const ButtonPreview = styled(Button)`
  opacity: 0.7;
  visibility: hidden;
  position: absolute;
  width: 50%;
  min-width: 90px;

  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;

  &:hover {
    opacity: 1;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${Container}:hover & {
    visibility: visible;
  }
`;
export const MagaluIndica = styled(Chip).attrs(props => Object.assign({}, props))`
  width: 66px;
`;
export const MercadoFull = styled(Chip).attrs(props => Object.assign({}, props))`
  width: 126px;
`;
export const ShippingDescription = styled(TextElement).attrs(() => ({
  fontSize: 0,
  fontWeight: 'medium',
  marginTop: 1
}))`
  color: ${getTextColor('primary')};
`;